export function indexByCell(cell, gridWidth) {
    return cell[1] * gridWidth + cell[0];
}
